module.exports = __webpack_public_path__ + "img/88.a8ec14f4.png";